export default __webpack_public_path__ + "static/media/Virtual5-mobi.79da40ae.webp";